import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Row, Col, Result } from 'antd';
import { toggleSideBar, getAccessRoutes, isAuthintecated, setIsHR } from './stores/actions'
import { getApi } from '../../shared/src/apis';
import { connect } from 'react-redux';
import { PrivteRoute } from "./utils/privteRoutes";
// import history from './utils/history';

import 'antd/dist/antd.css';
import 'react-phone-input-2/lib/style.css'
import './index.css'
import './scss/style.scss';

import Categories from './views/categories';
import { OutPutResult, NotFound, SideBar, ReleaseNotes, Navigation, Login, BrandLoader } from '@operations/shared'
// Token check removed - backend manages cookies (HttpOnly)
// Auth state is managed through Redux state
interface Props {
  authed: boolean,
  isHR: boolean,
  is_bar_collapsed: boolean,
  toggleSideBar: any,
  accessRoutes: [],
  getApi: any,
  getAccessRoutes: (arg0: []) => void,
  isAuthintecated: (value: boolean) => void,
  setIsHR: (value: boolean) => void
}
class App extends Component<Props> {
  state = {
    loadPermission: true,
    noPerrmision: false,
  }
  private tokenLogInterval?: number;

  componentDidMount() {
    // console.log(process.env);

    // console.log = function () { };
    this.checkTypeOfResponsive();
    this.getPermission();
  }

  componentWillUnmount() {
    if (this.tokenLogInterval) {
      window.clearInterval(this.tokenLogInterval);
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.accessRoutes && this.props.accessRoutes &&
      prevProps.accessRoutes.length !== this.props.accessRoutes.length &&
      this.props.accessRoutes.length > 0) {
      this.setState({ noPerrmision: false })
    }
  }

  getPermission = async () => {
    // Check auth status on page load/refresh
    // If API call succeeds, user is authenticated (cookies are valid)
    // If API call fails (401), user is not authenticated
    try {
      const permission = await this.props.getApi('users/get-permissions');
      if (permission?.payload?.status === 200) {
        // API call succeeded - user is authenticated
        this.props.isAuthintecated(true);
        this.props.setIsHR(permission?.payload?.isHR || false);
        this.setState({ loadPermission: false, noPerrmision: false })
        // this.setState({activePage:permission.payload.accessRoute[0].path})
        this.props.getAccessRoutes(permission.payload.accessRoutes || [])
      } else {
        // API call failed - user is not authenticated
        this.props.isAuthintecated(false);
        this.props.setIsHR(false);
        this.setState({ loadPermission: false, noPerrmision: true })
      }
    } catch (error: any) {
      // Only set auth to false if it's a 401 error
      // For other errors, keep current auth state
      if (error?.response?.status === 401 || error?.response?.data?.statusCode === 401) {
        // API call error (401) - user is not authenticated
        this.props.isAuthintecated(false);
        this.props.setIsHR(false);
        this.setState({ loadPermission: false, noPerrmision: true })
      } else {
        // Other errors (network, etc.) - keep current auth state
        this.setState({ loadPermission: false })
      }
    }
  }

  checkTypeOfResponsive = () => {
    let intFrameWidth: number = window.innerWidth;
    if (intFrameWidth <= 600) {
      this.props.toggleSideBar(!this.props.is_bar_collapsed)
    } else {
      this.props.toggleSideBar(this.props.is_bar_collapsed)
    }
  }



  render() {
    const { loadPermission, noPerrmision } = this.state;
    const { authed, isHR, accessRoutes, is_bar_collapsed } = this.props;
    // If loading, show spinner at top level
    if (loadPermission) {
      return (
        <div className="App">
          <BrandLoader />
        </div>
      );
    }

    return (
      <>
        <div className="App">
          <Router>
            <Switch>
              <Route exact path="/log-in" component={Login} />
              <Route path="*" render={() => (
                <div>
                  {authed && <Navigation />}
                  {noPerrmision && authed ? (
                    <Result
                      status="403"
                      title="Permission"
                      subTitle="You don't have permission to access this page"
                    />
                  ) : (
                    <Row>
                      {authed && (
                        <Col xs={!is_bar_collapsed ? 6 : 4}
                          md={!is_bar_collapsed ? 6 : 4}
                          lg={!is_bar_collapsed ? 4 : 2}>
                          <SideBar />
                        </Col>
                      )}
                      <Col
                        xs={!authed ? 24 : !is_bar_collapsed ? 18 : 20}
                        md={!authed ? 24 : !is_bar_collapsed ? 18 : 20}
                        lg={!authed ? 24 : !is_bar_collapsed ? 20 : 22}>
                        <Switch>
                          <Route exact path="/log-in" component={Login} />
                          {!isHR && <PrivteRoute path='/release-notes' component={ReleaseNotes} isLoading={loadPermission} />}
                          {accessRoutes.map((route: any) => (
                            <PrivteRoute 
                              key={route.path} 
                              exact 
                              path={`/${route.path}/:actionName?/:id?`} 
                              actionsAllowed={route.actions} 
                              pathUrl={route.path} 
                              component={Categories} 
                              isLoading={loadPermission} 
                              replace 
                            />
                          ))}
                            <PrivteRoute path='/' component={OutPutResult} isLoading={loadPermission} />
                          <PrivteRoute component={NotFound} isLoading={loadPermission} />
                        </Switch>
                      </Col>
                    </Row>
                  )}
                </div>
              )} />
            </Switch>
          </Router>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state: any) => ({
  authed: state.auth.authed,
  isHR: state.auth.isHR,
  accessRoutes: state.auth.accessRoutes,
  is_bar_collapsed: state.componentReducer.is_bar_collapsed,

})
export default connect(mapStateToProps, { toggleSideBar, getApi, getAccessRoutes, isAuthintecated, setIsHR })(App);
